import styled from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';

const StyledGallery = styled.div``;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 4fr);
  row-gap: ${({ theme }) => theme.spacings.x4};
  column-gap: 18px;
  grid-template-areas:
    'types .'
    'search filters'
    'activeFilters .'
    'main .'
    'showMore .';
  padding: 52px 0 ${({ theme }) => theme.spacings.x10};

  ${breakpoints.MD} {
    row-gap: ${({ theme }) => theme.spacings.x4};
    column-gap: ${({ theme }) => theme.spacings.x4};
    grid-template-columns: repeat(12, 12fr);
    grid-template-areas:
      'filters search'
      'filters types'
      'filters activeFilters'
      'filters main'
      'filters showMore';
    padding-top: 78px;
    grid-template-rows: auto auto 1fr auto;
  }

  ${breakpoints.MDL} {
    grid-template-areas:
      'filters types search'
      'filters activeFilters activeFilters'
      'filters main main'
      'filters showMore showMore';
  }

  ${breakpoints.LG} {
    grid-template-areas:
      'filters types search'
      'filters activeFilters activeFilters'
      'filters main main'
      'filters showMore showMore';
    padding-top: 82px;
  }
`;

const Types = styled.div`
  grid-area: types;
  grid-column: span 4;

  ${breakpoints.MD} {
    grid-column: span 8;
  }

  ${breakpoints.MDL} {
    grid-column: span 5;
  }

  ${breakpoints.LG} {
    grid-column: span 4;
  }
`;

const Search = styled.div`
  grid-area: search;
  grid-column: span 3;

  ${breakpoints.MD} {
    grid-column: span 8;
  }

  ${breakpoints.MDL} {
    grid-column: span 4;
  }

  ${breakpoints.LG} {
    grid-column: span 5;
  }
`;

const Filters = styled.aside`
  grid-area: filters;
  grid-column: span 1;

  ${breakpoints.MD} {
    grid-column: span 4;
    order: -1;
    //align-self: start;
    //position: sticky;
    //top: 112px;
  }

  ${breakpoints.MDL} {
    grid-column: span 3;
  }

  ${breakpoints.LG} {
    grid-column: span 3;
  }
`;

const ActiveFilters = styled.div`
  grid-area: activeFilters;
  grid-column: span 4;

  ${breakpoints.MD} {
    grid-column: span 8;
  }

  ${breakpoints.MDL} {
    grid-column: span 9;
  }

  ${breakpoints.LG} {
    grid-column: span 9;
  }
`;

const Main = styled.main`
  grid-area: main;
  grid-column: span 4;
  margin-top: -${({ theme }) => theme.spacings.x2};

  ${breakpoints.MD} {
    grid-column: span 8;
  }

  ${breakpoints.MDL} {
    grid-column: span 9;
  }

  ${breakpoints.LG} {
    grid-column: span 9;
  }
`;

const ShowMore = styled.div`
  grid-area: showMore;
  grid-column: span 4;
  margin-top: 22px;
  display: flex;
  justify-content: center;

  ${breakpoints.MD} {
    grid-column: span 8;
  }

  ${breakpoints.MDL} {
    grid-column: span 9;
  }

  ${breakpoints.LG} {
    grid-column: span 9;
  }
`;

export {
  StyledGallery,
  Grid,
  Types,
  Search,
  Filters,
  ActiveFilters,
  Main,
  ShowMore,
};
